// extracted by mini-css-extract-plugin
module.exports = {"Root":"SVGArrow_Root__Vg74z"};